<template>
  <v-dialog v-model="dialog.show" max-width="500px" scrollable >
    <v-card  v-if="dialog.owner_access"> 
      <v-card-title>
        <span class="headline modal-headline">{{ title }}</span>
        
      </v-card-title >
      <v-card-text >
          <v-skeleton-loader 
            :loading="loader.getUsers"
            type="list-item-avatar-two-line"
            class="mx-auto"
          >
            <v-tabs>
              <v-tab
                v-for="(tab,index) in tabs"
                :key="index"    
                :href="`#tab-${index}`"
              >
                {{tab.title}}
              </v-tab>  
              <v-tab-item
                v-for="(tab,index) in tabs"
                :key="index"
                :value="`tab-${index}`"
              >
                <v-card
                  flat
                  tile
                >
                  <v-card-text style="max-height:40vh;overflow: scroll">
                      <v-list-item-group
                        v-model="tab.selected"
                        multiple
                        active-class=""
                      >
                        <template v-for="(user,index) in users">
                          <v-list-item v-bind:key="'user-list-'+index" :value="user.id" >
                            <template v-slot:default="{ active }">
                              <v-list-item-action>
                                <v-checkbox color="primary" v-model="active"></v-checkbox>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title class="text-capitalize font-weight-bold">{{user.first_name + ' ' + user.last_name}}</v-list-item-title>
                                <v-list-item-subtitle>{{user.email}}</v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </template>
                      </v-list-item-group>
                  </v-card-text>
                  <v-card-actions v-if="dialog.children" class="pa-4 grey lighten-3 ">
                    <v-checkbox 
                    class="transparent pt-0 ma-0" 
                    dense
                    v-model="tab.subfolders" 
                    persistent-hint
                    hint="* If you deselect this option, then all sub-folders will retain their own access privileges"
                    label="Assign the same access privileges to all sub-folders *" />
                  </v-card-actions>
                </v-card>
              </v-tab-item>
            </v-tabs>
          

          </v-skeleton-loader>
      </v-card-text>
      <v-card-actions class="pa-5">
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" outlined text @click="dialog.show = false">Close</v-btn>
        <v-btn dark @click="save" :loading="loader.save">Save</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="!dialog.owner_access">
      <v-card-text class="pt-10" v-if="!dialog.owner_access" align="center">
        <h2>Access Denied!</h2>
        <p>
          Only folder owner can set the Permissions for other users!
        </p>
        <v-btn dark @click="dialog.show = false">OK</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
  
</template>
<script>
import { $folders } from '@/services'
export default {
  data() {
    return {
      loader: {
        save : false,
        getUsers: false,
      },
      tabs:[
        {
          title: 'owners',
          selected: [],
          subfolders: false
        },
        {
          title: 'editors',
          selected: [],
          subfolders: false
        }
      ],
      users: [],
      title: 'Edit Privileges',
      info: {name:''},
    }
  },
  props: {
    dialog: {
      type: Object,
      default: {
        show: false,
        folder_id: null,
        owner_access: null,
        children: false
      }
    }
  },
  watch: {
    'dialog.show': function (new_value, old_value) {
      if(new_value){
        if(this.dialog.owner_access){
          this.getUsers()
          this.getEditInfo()
        }
      }
    },
  },
  methods: {
    toggle() {
      this.active = !this.active;
    },
    assign(val, ind) {
      if (ind > 0) {
        if (val == 'tab_owners') {
          if (this.owners.includes(ind) === false) this.owners.push(ind);
        } else if (val == 'tab_editors') {
          if (this.editors.includes(ind) === false) this.editors.push(ind);
        }
      }
    },
    save(){
      this.loader.save = true
      $folders.update(this.info.id,{
        folder:{
          name: this.info.name,
          folder_type: this.info.folder_type,
          privacy: "true",
          owner_ids: this.tabs[0].selected,
          editor_ids: this.tabs[1].selected,
          owner_access: this.tabs[0].subfolders,
          editor_access: this.tabs[1].subfolders
        }
      }).then(response=>{
        this.$store.commit('ui/snackbar',{
          message : 'Privacy Permissions Saved Successfully.',
          type: 'success'
        })
        this.dialog.show = false
      }).catch(error=>{
        
      }).finally(()=>{
        this.loader.save = false
      })
    },
    getEditInfo(){
      $folders.getInfo(this.dialog.folder_id).then(response => {
        this.info = response.data.data.folder
        this.tabs[0].selected = this.info.owner_ids
        this.tabs[1].selected = this.info.editor_ids
        this.tabs[0].subfolders = this.info.owner_access
        this.tabs[1].subfolders = this.info.editor_access
      }).catch(error=>{
        console.log('Error:folders.getEditInfo',error)
      })
    },
    getUsers() {
      this.loader.getUsers = true
      $folders.getUsersList().then(response => {
        this.users = response.data.data.users
      }).catch(error=>{
        console.log('Error:folders.getusers',error)
      }).finally(()=>{
        this.loader.getUsers = false
      })
    }
  }
}
</script>
<style scoped lang="scss">
  $white: #fff;
  .v-dialog {
    border-radius: 2px;
    * {
      background-color: $white;
    }
    .modal-headline {
      font-size: 1.2rem !important;
      font-weight: 500;
    }
  }
  .btn {
    &.btn-lined {
      text-transform: uppercase;
      font-family: Roboto sans-serif;
      height: 36px;
      min-width: 64px;
      padding: 0 16px;
      margin: 0 auto;
      margin-top: -3px;
    }
  }
  .v-tabs-slider-wrapper {
    transform: translateX(0px) !important;
  }
</style>
